import { createContext, useContext } from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "./permissions";
import { Toast } from "./Toast_";

/**
 * The permission section ("genre", "banners", …) the page on screen belongs
 * to. PermissionRoute sets it, so shared buttons can hide themselves when a
 * sub-admin may only view that section — without every page having to check.
 */
const ModuleAccessContext = createContext(null);

export const ModuleAccessProvider = ModuleAccessContext.Provider;

/**
 * Whether the signed-in admin may do `action` (view / edit / delete) on the
 * current page. Pages that are not behind a PermissionRoute have no section,
 * so nothing is hidden there — the API still refuses what is not allowed.
 */
export const useCanInCurrentSection = (action) => {
  const module = useContext(ModuleAccessContext);
  const { admin } = useSelector((state) => state.admin);

  if (!module) return true;
  if (admin?.role !== "SUB_ADMIN") return true;
  return hasPermission(admin, module, action);
};

let lastDeniedAt = 0;

/**
 * Tell a sub-admin the API refused something they are not allowed to do. Some
 * buttons are not hidden by the check above, and without this a refused click
 * would look like nothing happened. One toast per burst of refused requests.
 */
export const notifyPermissionDenied = (message) => {
  const now = Date.now();
  if (now - lastDeniedAt < 2000) return;
  lastDeniedAt = now;
  Toast("error", message || "You do not have permission to do this.");
};
